export const MOBILE_DRAWER_BREAKPOINT = 'md';
export const DRAWER_WIDTH = 280;
export const DRAWER_EXPANDED_WIDTH = 227;
export const DRAWER_COLLAPSED_WIDTH = 52;
export const FONT_URL =
    'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap';
